<template>

    <div>

        <v-flex xs12 sm10 offset-sm1 md8 offset-md2 lg6 offset-lg3>
            <!-- Alert -->
            <Alert v-if="alertType !== ''" :atype="alertType" :message="alertMessage" :visibility="visibility" />

            <v-progress-linear v-if="progressbar" :indeterminate="true"></v-progress-linear>

            <!-- form-->
            <v-container>

                <v-card class="semi-transparent-5-bg">

                    <v-card-title style="border-bottom: 5px solid #3944bb">

                        <img src="//assets.office4u.xyz/photos/BO-Demo/blue-deposit-svg.svg" style="float: left; width: 15%; max-width: 50px; margin-right: 15px;"/>

                        <div class="deposit-form-title">

                            <span>{{ $t( 'deposit.title').toUpperCase() }}</span>

                        </div>

                    </v-card-title>

                    <v-card-text>

                        <v-form ref="form" v-model="valid" lazy-validation>

                            <!-- Product -->
                            <v-layout row class="margin-5-top-bottom">
                                <v-flex xs4>
                                    <v-subheader class="inputlabel">Product</v-subheader>
                                </v-flex>

                                <v-flex xs8 class="margin-16-right">
                                    <v-select class="deposit-form" :label="$t( 'deposit.bank_account' )" :items="[product]" :value="product" single-line disabled return-object>
                                        <template slot="selection" slot-scope="data">
                                            <img :src="data.item.logo" width="35px;" style="margin-right: 5px;"/>
                                            {{ data.item.name  }}
                                        </template>
                                    </v-select>
                                </v-flex>
                            </v-layout>

                            <div style="margin-bottom: 1em;"></div>

                            <!-- Bank Account -->
                            <v-layout row class="margin-5-top-bottom">
                                <v-flex xs4>
                                    <v-subheader class="inputlabel">{{ $t( 'deposit.bank_account' ) }}</v-subheader>
                                </v-flex>

                                <v-flex xs8 class="margin-16-right">
                                    <v-select :label="$t( 'deposit.bank_account' )" :items="bankAccounts" v-model="data.selectedBank" item-value="id" :rules="bankAccountRules" single-line return-object>
                                        <template slot="selection" slot-scope="data">
                                            <span>{{ data.item.name + '- ' + data.item.bank.short_name }}</span>
                                        </template>

                                        <template slot="item" slot-scope="data">
                                            <span>{{ data.item.name + '- ' + data.item.bank.short_name }}</span>
                                        </template>
                                    </v-select>
                                </v-flex>
                            </v-layout>

                            <div style="margin-bottom: 1em;"></div>

                            <v-list v-if="data.selectedBank" class="semi-transparent-5-bg overflow-x-auto" two-line>

                                <v-list-tile>

                                    <v-list-tile-avatar>
                                        <img :src="data.selectedBank.bank.logo_url">
                                    </v-list-tile-avatar>

                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ data.selectedBank.name }}</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ data.selectedBank.acc_no }}</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-btn icon ripple>
                                            <v-icon color="grey lighten-1" @click.prevent='copyBankAcc(data.selectedBank.acc_no)'>file_copy</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>

                                </v-list-tile>

                            </v-list>

                            <div style="margin-bottom: 1em;"></div>

                            <!-- Transaction_date -->
                            <v-layout row class="margin-5-top-bottom">

                                <v-flex xs4>

                                    <v-subheader class="inputlabel">{{ $t( 'deposit.transfer_date' ) }}</v-subheader>

                                </v-flex>


                                <v-flex xs8 class="margin-16-right">

                                    <v-datetime-picker id="dateTimePickerField" v-model="data.transferDateTime" @input="changeDateFormat()"> </v-datetime-picker>

                                </v-flex>

                            </v-layout>

                            <div style="margin-bottom: 1em;"></div>

                            <!-- Amount -->
                            <v-layout row class="margin-5-top-bottom">

                                <v-flex xs4>

                                    <v-subheader class="inputlabel">{{ $t('deposit.amount', { currency : this.$store.getters.currency }) }}</v-subheader>

                                </v-flex>

                                <v-flex xs8 class="margin-16-right">

                                    <v-text-field  id="amountField" v-model="data.amount" class="amountField" :rules="amountRules" single-line box required></v-text-field>

                                </v-flex>

                            </v-layout>

                            <div style="margin-bottom: 1em;"></div>

                            <!-- Payment_method -->
                            <v-layout row class="margin-5-top-bottom">

                                <v-flex xs4>

                                    <v-subheader class="inputlabel">Method</v-subheader>

                                </v-flex>

                                <v-flex xs8 class="margin-16-right" style="padding-top: 10px;">

                                    <v-radio-group v-model="data.selectedMethod" :rules="methodRules" row >

                                        <v-radio v-for="(method, i) in methods" :label="$t( `deposit.${method}` )" :key="i" :value="method"></v-radio>

                                    </v-radio-group>

                                </v-flex>

                            </v-layout>

                            <!-- Ref_no -->
                            <v-layout row class="margin-5-top-bottom">

                                <v-flex xs4>

                                    <v-subheader class="inputlabel">{{ $t( 'deposit.ref_no' ) }}</v-subheader>

                                </v-flex>

                                <v-flex xs8 class="margin-16-right">

                                    <v-text-field id="refField" class="refField deposit-form" v-model="data.referenceNo" single-line box required></v-text-field>

                                </v-flex>

                            </v-layout>

                            <div style="margin-bottom: 1em;"></div>

                            <!-- Receipt -->
                            <v-layout row class="margin-5-top-bottom">

                                <v-flex xs4>

                                    <v-subheader class="inputlabel">Receipt</v-subheader>

                                </v-flex>

                                <v-flex xs8 class="margin-16-right">

                                    <v-flex xs12 style="display: flex; flex-wrap: wrap; align-items: center;">

                                        <v-btn @click.prevent="pickFile" small class="font-size">
                                            Attachment
                                        </v-btn>

                                        <span>{{ data.imageName }}</span>

                                    </v-flex>

                                </v-flex>

                            </v-layout>

                            <input type="file" style="display: none" ref="image" accept="image/*" name="image_file" @change="onFilePicked">

                            <div style="margin-bottom: 1em;"></div>

                            <!--Promotion -->
                            <v-layout row class="margin-5-top-bottom">

                                <v-flex xs4>

                                    <v-subheader class="inputlabel">Promotion</v-subheader>

                                </v-flex>

                                <v-flex xs8 class="margin-16-right">

                                    <v-select :items="promotions" v-model="data.selectedPromotion" item-text="name" item-value="promotion_id"></v-select>

                                </v-flex>

                            </v-layout>

                            <div style="margin-bottom: 1em;"></div>

                            <v-layout row justify-center>

                                <v-btn :disabled="!valid" color="success" @click.prevent="submit" small class="font-size">
                                    {{ $t( 'shared.submit' ) }}
                                </v-btn>

                                <v-btn color="error" @click.prevent="reset" small class="font-size">
                                    {{ $t( 'shared.reset' ) }}
                                </v-btn>

                            </v-layout>

                        </v-form>

                    </v-card-text>

                </v-card>

            </v-container>

        </v-flex>

        <!-- Snackbar -->
        <div v-if="ready == true">

            <snackbar :color="color" :icon="icon" :text="message" :show="snackbar" />

        </div>

    </div>

</template>

<script>
import snackbar from '@/components/Reusable/Snackbar.vue';
import Alert from "@/components/Reusable/Alert.vue";
import moment from "moment";
import Api from "@/api";

export default {
    name: 'Deposit',
    data() {
        return {
            /**
            * Form Variable
            */
            valid: true,
            data: {
                selectedBank: null,
                selectedPromotion: 0,
                selectProduct: '',
                selectedMethod: '',
                transferDateTime: moment().format("YYYY-MM-DD HH:mm"),
                amount: 0,
                referenceNo: '',
                minDepositAmount: 100,
                imageName: '',
                imageFile: '',
                imageFileType: '',
            },
            product: null,
            bankAccounts: [],
            promotions: [],
            methods: [
               'Online',
               'ATM'
            ],
            // Others variable
            alertType: "",
            alertMessage: "",
            visibility: false,
            progressbar: false,
            snackbar: false,
            message: "",
            color: "",
            icon: "",
            ready: false,
        }
    },
    components: {
        Alert,
        snackbar,
    },
    mounted() {
        // Check Game selected or not, not route to game list

        if(!(this.$route.params.product)) {

            return this.$router.push({name: 'Game'});
        } else {

            this.product = this.$route.params.product;
            this.data.selectProduct = this.$route.params.product.id;
            this.getMinDeposit();
        }

        this.getFormData();

        $('input[type=text]').focus(function() {

            let targetParentId = null;

            targetParentId = $(this).attr('id');

           focusFormFieldAnimation(targetParentId);

        });

        $('input[type=text]').focusout(function() {

            let targetParentId = null;

            targetParentId = $(this).attr('id');

            unfocusFormFieldAnimation(targetParentId);

        });

         function focusFormFieldAnimation(targetParentId) {

            let targetParentClass = null;

            targetParentClass = $('.' + targetParentId + ' .v-input__control .v-input__slot');

            targetParentClass.css('text-shadow','0px 0px 2px #ccc');

            targetParentClass.css('box-shadow','0 0 2px #fff, 0 0 5px #fff, 0 0 10px #fff');

            targetParentClass.css('transition-delay','0.1s');
        }

        function unfocusFormFieldAnimation(targetParentId) {

            let targetParentClass = null;

            targetParentClass = $('.' + targetParentId + ' .v-input__control .v-input__slot');

            targetParentClass.css('text-shadow','');

            targetParentClass.css('box-shadow','');

            targetParentClass.css('transition-delay','');
        }

    },
    watch: {
        'message': function(message) {
            let currentInstance = this;

            setTimeout(function() {
                currentInstance.ready = false;
                currentInstance.snackbar = false;
                if (message == currentInstance.$t( 'deposit.submit_ticket_success' )) {
                    return currentInstance.$router.push({
                        name: 'home'
                    });
                }
            } , 1500);

        }
    },
    computed: {
        amountRules() {
            return [
                    v => !!v || this.$t( 'deposit.require_amount_validation_rule' ),
                    v => (v && v >= parseFloat(this.data.minDepositAmount)) || this.$t( 'deposit.min_amount_validation_rule', { amount: this.data.minDepositAmount, currency : this.$store.getters.currency} ),
                    // v => (v && v < 10000) || 'Max Amount is RM10,000'
            ]
        },
        bankAccountRules() {
            return [
                   v => !!v || this.$t( 'deposit.bank_acc_validation_rule' )
            ]
        },
        methodRules() {
            return [
                v => !!v || this.$t( 'deposit.method_validation_rule' )
            ]
        },
    },
    methods: {
        getImgUrl(name) {

            var images = require.context('@/assets/', false, /\.png$/);

            return images('./' + name + ".png");

        },
        reset() {

            this.data.amount = 0;

            this.data.selectedBank = '';

            this.data.selectedPromotion = '';

            this.data.selectedMethod = '';

            this.data.referenceNo = '';

            this.data.imageName = '';

            this.data.imageFile = '';

            this.data.imageFileType = '';

        },
        async submit() {

            if (this.formValidation()) {

                const data = new FormData();

                data.append('access_token' , this.$store.getters.user_token);

                data.append('ref_no' , this.data.referenceNo);

                data.append('product_to' , this.data.selectProduct);

                data.append('bank_acc_id' , this.data.selectedBank.id);

                data.append('method' , this.data.selectedMethod);

                data.append('amount', this.data.amount);

                data.append('promotion_id', this.data.selectedPromotion);

                data.append('transferDateTime',this.data.transferDateTime);

                if (this.data.imageFile) {

                    data.append('receipt_image', this.data.imageFile);

                    data.append('receipt_image_type', this.data.imageName);

                }

                let res = await Api.postDeposit(data);

                if (res && 'success' in res && res.success === true) {

                    this.message = res.message;

                    if ( this.message == "Submit Ticket Successfully" ) {

                        this.message = this.$t( 'deposit.submit_ticket_success' );

                    }

                    this.icon = "done_all";

                    this.color = "green";

                    this.snackbar = true;

                    this.ready = true;

                } else {

                    this.visibility = true;

                    this.alertMessage = res.message;

                    this.alertType = "error";

                    if(res.message == "token invalid") {

                        this.$store.dispatch('logout', res.data);

                        this.$router.push({name: 'login'})

                    } else if(res.message == "Ticket Detail Invalid") {

                        for (var oprop in res.data) {

                            this.alertMessage += '<br>' + res.data[oprop];

                        }

                    } else {

                        if(typeof res.data === 'string' ) {

                            this.alertMessage = res.data;

                        }

                    }

                }

            }

        },
        async getFormData() {

            this.progressbar = true;

            if(this.$store.getters.user_token != "") {

                await this.getBankAccounts();

                await this.getMemberPromotions();

                this.progressbar = false;

            } else {

                this.$router.push({name: 'login'})

            }

        },
        async getBankAccounts() {

            let res = await Api.getBankAccounts({
                access_token: this.$store.getters.user_token
            });

            if (res && 'success' in res && res.success === true) {

                this.bankAccounts = res.data;

            } else {

                this.visibility = true;

                this.alertMessage = res.message;

                this.alertType = "error";

                if(res.message == "token invalid") {

                    this.$store.dispatch('logout', res.data);

                    this.$router.push({name: 'login'})

                }

            }

        },
        async getMemberPromotions() {

            let res = await Api.getMemberPromotions({
                access_token: this.$store.getters.user_token,
                productTo: this.data.selectProduct
            });

            let currentInstance = this;

            if (res && 'success' in res && res.success === true) {

                currentInstance.promotions.push({
                    id: 0,
                    name: "Don't get any bonus",
                    promotion_id: ""
                });

                res.data.map(function(promotion) {
                    currentInstance.promotions.push(promotion);
                });

            } else {

                this.visibility = true;

                this.alertMessage = res.message;

                this.alertType = "error";

                if(res.message == "token invalid") {

                    this.$store.dispatch('logout', res.data);

                    this.$router.push({name: 'login'})

                }

            }

        },
        async getMinDeposit() {

            let res = await Api.getMinDeposit();

            if (res) {

                this.data.minDepositAmount = res;

            }

        },
        copyBankAcc(copiedText) {

            let input = document.createElement('input');

            document.body.appendChild(input);

            input.value = copiedText;

            input.select();

            try {

                let successful = document.execCommand('copy');

                this.message = this.$t( 'shared.copied' );

                this.icon = "done_all";

                this.color = "green";

                this.snackbar = true;

                this.ready = true;

            } catch (err) {

                alert(this.$t( 'shared.opp_unable_copy' ));

            }

            document.body.removeChild(input);

        },
        pickFile () {

            this.$refs.image.click();

        },
		onFilePicked (e) {

            const files = e.target.files;

            if (files[0] !== undefined) {

                this.data.imageName = files[0].name;

                this.data.imageFile = files[0];

                this.data.imageFileType = files[0].type;

			} else {

                this.data.imageName = '';

                this.data.imageFile = '';

                this.data.imageFileType = '';

			}
        },
        formValidation () {

            if (this.data.selectedBank && this.data.selectedMethod != '' && this.data.amount) {

                if ( this.data.imageName !== '' ) {

                    if (! this.data.imageFileType.includes('image')){

                        this.message = this.$t( 'deposit.invalid_image_type' );

                        this.icon = "clear";

                        this.color = "red";

                        this.snackbar = true;

                        this.ready = true;

                        return false;

                    } else {

                        return true;

                    }

                }else {

                    return true;

                }

            } else {

                this.message = this.$t( 'deposit.not_completed_form' );

                this.icon = "clear";

                this.color = "red";

                this.snackbar = true;

                this.ready = true;

                return false;

            }

        },
        changeDateFormat() {

            this.data.transferDateTime = moment(this.data.transferDateTime).format("YYYY-MM-DD HH:mm");

        }
    }
}
</script>

<style scoped>

    .v-input--selection-controls {
        padding-top: 0px;
        margin-top: 0px;
    }

    .font-size {
        font-size: 12px;
    }

    .v-application .grey--text.text--lighten-1 {
        color: #bdbdbd !important;
        caret-color: #bdbdbd !important;
    }

    .inputlabel {
        color: #4d4a4a;
        font-weight: bold;
    }

    .deposit-form-title{
        font-size: calc(1.0em + 1.5vmin);
        color: #3944bb;
    }

</style>

<style>

    .gj-datepicker-md {
        width: 100%;
        color: #fff!important;
    }

    .v-text-field {
        padding-top: 0px !important;
        margin-top: 0px !important;
    }

</style>
